import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store/store.js'
import vuetify from './plugins/vuetify'
import title from './plugins/title.js'
import * as firebase from 'firebase'
import errorAlert from './components/AuthError.vue'
import editDialog from './components/Member/EditMember.vue'
import deleteDialog from './components/Member/DeleteMember.vue'
import addCalendarEvent from './components/Calendar/AddCalendarEvent.vue'
import editCalendarEvent from './components/Calendar/EditCalendarEvent.vue'
import deleteCalendarEvent from './components/Calendar/DeleteEvent.vue'
import addChannel from './components/ChannelStat/AddChannel.vue'
import ratingDialog from './components/Vote/Rating.vue'
import DateFilter from './plugins/date'
import VueClock from '@dangvanthanh/vue-clock'
import Embed from 'v-video-embed'
import { Plotly } from 'vue-plotly'
import deleteVote from './components/Vote/DeleteVote.vue'
import deleteChannel from './components/ChannelStat/DeleteChannel.vue'
import deleteEquipment from './components/Resource/DeleteEquipment.vue'

Vue.config.productionTip = false
Vue.mixin(title)
Vue.component('error-alert', errorAlert)
Vue.component('edit-member-dialog', editDialog)
Vue.component('delete-member-dialog', deleteDialog)
Vue.component('add-calendar-event', addCalendarEvent)
Vue.component('edit-calendar-event', editCalendarEvent)
Vue.component('delete-calendar-event', deleteCalendarEvent)
Vue.component('add-channel-dialog', addChannel)
Vue.component('rating-dialog', ratingDialog)
Vue.filter('date', DateFilter)
Vue.component(VueClock)
Vue.use(Embed)
Vue.component('Plotly', Plotly)
Vue.component('delete-vote-dialog', deleteVote)
Vue.component('delete-channel-dialog', deleteChannel)
Vue.component('delete-equipment-dialog', deleteEquipment)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  created () {
    firebase.initializeApp({
      apiKey: 'AIzaSyABAmXGPp3GDOLOcNDL2gR9J22yQH66YH8',
      authDomain: 'fyp-website-3f6ab.firebaseapp.com',
      databaseURL: 'https://fyp-website-3f6ab.firebaseio.com',
      projectId: 'fyp-website-3f6ab',
      storageBucket: 'fyp-website-3f6ab.appspot.com',
      messagingSenderId: '467754691950',
      appId: '1:467754691950:web:bdd69f47b574dd8150e57f',
      measurementId: 'G-FVT8PF8TXV'
    })
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.dispatch('autoSignIn', user)
      }
    })
    this.$store.dispatch('loadMembers')
    this.$store.dispatch('loadCalendarEvents')
    this.$store.dispatch('loadVideoIdeas')
    this.$store.dispatch('loadChannelIds')
    this.$store.dispatch('loadEquipments')
    this.$store.dispatch('loadChannelDatas')
  }
}).$mount('#app')
